import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { NgGlyph } from "@ng-icons/core";
import { DashboardOverviewCard } from "../../Dto/DashboardOverviewResponse";

@Component({
  standalone: true,
  selector: "app-dashboard-overview-cards",
  imports: [CommonModule, NgGlyph],
  templateUrl: "./DashboardOverviewCards.html",
  styleUrl: "./DashboardOverviewCards.scss",
})
export class DashboardOverviewCards {
  @Input({ required: true }) cards: DashboardOverviewCard[] = [];
  @Input({ required: true }) loading = false;
  @Input({ required: true }) selectedPeriodLabel = "";

  formatValue(value: number): string {
    return new Intl.NumberFormat("en-US").format(value);
  }

  formatPercentage(value: number): string {
    const prefix = (() => {
      if (value > 0) {
        return "+";
      }
      return "";
    })();
    return `${prefix}${value.toFixed(1)}%`;
  }

  getTrendIcon(card: DashboardOverviewCard): string {
    if (card.direction === "up") return "trending_up";
    if (card.direction === "down") return "trending_down";
    return "trending_flat";
  }

  getSparklineHeight(card: DashboardOverviewCard, value: number): number {
    const max = Math.max(...card.sparkline, 0);
    if (max <= 0) {
      return 12;
    }

    return Math.max(12, Math.round((value / max) * 42));
  }

  getSkeletonCards(): number[] {
    return [1, 2, 3, 4, 5];
  }
}
